import { motion } from "framer-motion";

const steps = [
  ["01", "Understand Client Objectives", "Discovery. Constraints. Mission profile."],
  ["02", "Market Intelligence", "Comparables, demand trends, fleet analytics."],
  ["03", "Aircraft Research", "Long-list, short-list, availability, exclusivity."],
  ["04", "Technical Due Diligence", "Records, engine, airframe, maintenance programme."],
  ["05", "Commercial Negotiation", "Structure, pricing, deposits, guarantees."],
  ["06", "Documentation", "LOI, APA, escrow, delivery conditions."],
  ["07", "Transaction Closing", "Escrow release. Title. Registration."],
  ["08", "Post Delivery Support", "Operator onboarding. Fleet integration."],
];

export default function Process() {
  return (
    <section data-testid="process-section" className="py-32 md:py-40 border-t border-[#0E1B2E]/10 bg-white">
      <div className="max-w-[1440px] mx-auto px-6 md:px-10">
        <div className="grid grid-cols-12 gap-8 mb-20">
          <div className="col-span-12 md:col-span-4">
            <div className="flex items-center gap-3 text-[#A5854C] mb-6">
              <div className="hairline w-12"></div>
              <span className="font-mono text-[11px] uppercase tracking-[0.35em]">Method</span>
            </div>
            <h2 className="font-serif font-light tracking-[-0.02em] text-[#0E1B2E] text-[36px] md:text-[56px] leading-[1.02]">
              Eight steps.<br/><span className="italic text-[#A5854C]">Zero shortcuts.</span>
            </h2>
          </div>
          <div className="col-span-12 md:col-span-8 flex items-end">
            <p className="text-[#6B7684] text-[15px] md:text-[17px] leading-relaxed max-w-2xl">
              Every JS Aviation engagement follows the same disciplined process — the framework used by institutional aircraft investors and lessors. Slow when it must be. Fast when it can be.
            </p>
          </div>
        </div>

        <div className="relative">
          <div className="absolute left-6 md:left-8 top-0 bottom-0 w-px bg-[#0E1B2E]/10"></div>
          <div className="space-y-1">
            {steps.map(([n, t, d], i) => (
              <motion.div
                key={n}
                initial={{ opacity: 0, x: -20 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true, amount: 0.4 }}
                transition={{ duration: 0.7, delay: i * 0.05 }}
                className="relative pl-16 md:pl-24 py-8 border-b border-[#0E1B2E]/5 group"
                data-testid={`process-step-${n}`}
              >
                <div className="absolute left-3 md:left-5 top-8 w-6 h-6 border border-[#C8A97E]/50 bg-white flex items-center justify-center group-hover:border-[#A5854C] transition-colors">
                  <span className="w-1.5 h-1.5 bg-[#A5854C] rounded-full"></span>
                </div>
                <div className="grid grid-cols-12 gap-6 items-start">
                  <span className="col-span-12 md:col-span-1 font-mono text-[11px] uppercase tracking-[0.28em] text-[#9AA3AE]">{n}</span>
                  <h3 className="col-span-12 md:col-span-5 font-serif text-[22px] md:text-[28px] text-[#0E1B2E] tracking-tight leading-tight">{t}</h3>
                  <p className="col-span-12 md:col-span-6 text-[#6B7684] text-[14px] md:text-[15px] leading-relaxed">{d}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
